import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AiFillCamera, AiOutlineClose } from "react-icons/ai";
import { useHistory } from "react-router-dom";
import { uploadProfilePicture } from "../../actions/profile.action";
import ErrorInputComponent from "../../components/ErrorInputComponent";
import DocButtomButton from "../../components/DocButtomButton";
import "./onboarding.css";

export default function AddImagePage() {
  const history = useHistory();
  const dispatch = useDispatch();

  const [buttonState, setButtonState] = useState(false);
  const [errors, setErrors] = useState({
    imageUrl: "",
  });
  const [imageDetails, setImageDetails] = useState({
    imagePreview: "",
    file: "",
  });

  const handleSubmit = () => {
    const imageFile = imageDetails.file;
    if (imageFile !== "") {
      const navigateLink = () => history.push("/onboarding/create-password");
      dispatch(uploadProfilePicture(imageFile, navigateLink));
    } else {
      setErrors({
        ...errors,
        imageUrl: "Please upload your profile picture",
      });
    }
  };

  const onImageUpload = (event) => {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      let file = event.target.files[0];
      reader.onloadend = () => {
        setImageDetails({
          ...imageDetails,
          imagePreview: reader.result,
          file: file,
        });
        setErrors({
          ...errors,
          imageUrl: "",
        });
      };
      reader.readAsDataURL(file);
    }
  };

  console.log(errors);

  return (
    <div className="flex flex-column justify-center">
      <div className="App-height p-5 md:w-1/3">
        <div>
          <AiOutlineClose
            size={25}
            className="mt-5"
            onClick={() => history.goBack()}
          />
          <h1 className="a_acc_header mt-5">Upload Profile Photo</h1>
          <p className="a_acc_header_text">
            Add additional information that would allow people know who you are
            what you do.
          </p>
        </div>
        <div className="h-20">
          {imageDetails.imagePreview !== "" ? (
            <div className="mt-10 flex flex-wrap justify-center">
              <div className="">
                <img
                  src={imageDetails.imagePreview}
                  alt="..."
                  className="shadow rounded-full w-20 h-20 align-middle border-none"
                />
              </div>
            </div>
          ) : (
            <div className="mt-10 flex justify-center">
              <AiFillCamera
                size={70}
                color="#1a5304"
                className="bg-gray-100 rounded-full p-5 h-auto w-20"
              />
            </div>
          )}
        </div>

        <div className="flex mt-20">
          <label className="cameraButton bg-gray-100 hover:bg-gray-100 rounded-lg px-3 py-2">
            <div className="flex">
              <AiFillCamera size={20} color="gray" className="mr-2" />
              Select Photo
            </div>
            <input
              type="file"
              accept="image/*;capture=camera"
              onChange={(e) => onImageUpload(e)}
              name={"imageUrl"}
            />
          </label>
        </div>
        <ErrorInputComponent error={errors.imageUrl} />
        <div className="mt-52">
          <DocButtomButton
            name={"Next"}
            func={handleSubmit}
            isDisabled={buttonState}
          />
        </div>
      </div>
    </div>
  );
}
